import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import Config from "src/config.json";
import DatePikerForm from "src/component/Util/DatePikerForm";
import EventPeriodForm from "src/component/SafetyMap/EventPeriodForm";
import EventDetail from "src/component/SafetyMap/EventDetail.js";
import EventStatsInfo from "src/component/SafetyMap/EventStatsInfo";
import Modal from "src/js/Modal.js";
import Cognito from "src/js/Cognito.js";
import ApiErrorModal from "src/js/ApiErrorModal.js";
import Api from "src/js/Api.js";
import moment from "moment";

class SafetyMap extends Component {
  constructor() {
    super();
    let today = new Date();
    this.state = {
      // ログイン中ユーザ
      cognitoUser: [],
      // ログイン者のsub
      sub: "",
      // 車両のカープレートNO
      carPlateNo: "",
      // 選択可能な最小の日
      minDate: "0/1/2018",
      // 車両のID
      logCarId: "",
      // イベント種別 デフォルトはHarsh Braking
      eventType: "2",
      // 取得年
      targetYear: "",
      // 取得月
      targetMonth: "",
      // イベントGPSデータ
      safetyMapData: {},
      // 静的事故情報データ
      accidentDataList: {},
      // 表示ローディング
      safetyMapLoading: false,
      // 情報存在フラグ
      isSafetyMap: false,
      // 事故データ存在フラグ
      isAccidentData: true,
      // 表示期間：From
      eventPeriodFrom: 0,
      // 表示期間：To
      eventPeriodTo: 23,
      modalApiPath: "",
      modalStatusCode: "",
      modalErrorMessage: "",
      modalApiMessage: "",
      today: `${("0" + today.getDate()).slice(-2)}/${("0" + (today.getMonth() + 1)).slice(-2)}/${today.getFullYear()}`,
    };

    this.getPeriodSpecifiedSafetyMapData = this.getPeriodSpecifiedSafetyMapData.bind(
      this
    );
    this.getLocalStorageData = this.getLocalStorageData.bind(this);
    this.selectDate = this.selectDate.bind(this);
    this.selectPeriodFrom = this.selectPeriodFrom.bind(this);
    this.selectPeriodTo = this.selectPeriodTo.bind(this);
    this.selectEventType = this.selectEventType.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.getSafetyMapData = this.getSafetyMapData.bind(this);
    // this.getAccidentData = this.getAccidentData.bind(this);
  }

  componentWillMount() {
    // 認証チェック
    if (Cognito.signInCheck()) {
      // ユーザを取得
      this.setState({ cognitoUser: Cognito.getCognitoUser() });
    }
    // 描画前にローカルストレージからデータを取得する
    this.getLocalStorageData();
  }

  componentDidMount() {
    // ページの一番上までスクロール
    window.scrollTo(0, 0);
    this.getPeriodSpecifiedSafetyMapData();
  }

  handleHideModal() {
    this.setState({ showModal: false });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  // ローカルストレージの値を取得
  getLocalStorageData() {
    // サブ情報
    let sub = localStorage.getItem("sub");
    if (sub) {
      this.setState({
        sub: sub,
      });
    }

    // カープレートNO
    let carPlateNo = localStorage.getItem("carPlate");
    if (carPlateNo) {
      this.setState({
        carPlateNo: carPlateNo,
        carInfoLoading: true,
        isCarInfo: true,
      });
    }

    // ログカーID
    let logCarId = localStorage.getItem("logCarId");
    if (logCarId) {
      this.setState({
        logCarId: logCarId
      });
    }

    // イベントタイプ
    let eventType = localStorage.getItem("eventType");
    if (eventType) {
      this.setState({
        eventType: eventType
      });
    }

    // 取得年
    let targetYear = localStorage.getItem("targetYear");
    if (targetYear) {
      this.setState({
        targetYear: targetYear
      });
    }

    // 取得月
    let targetMonth = localStorage.getItem("targetMonth");
    if (targetMonth) {
      this.setState({
        targetMonth: targetMonth
      });
    }

    // 表示期間：From
    let eventPeriodFrom = localStorage.getItem("eventPeriodFrom");
    if (eventPeriodFrom) {
      this.setState({
        eventPeriodFrom: eventPeriodFrom
      });
    }

    // 表示期間：To
    let eventPeriodTo = localStorage.getItem("eventPeriodTo");
    if (eventPeriodTo) {
      this.setState({
        eventPeriodTo: eventPeriodTo
      });
    }
  }

  // 日付選択時情報を再取得
  selectDate(date) {
    const targetYear = date.year();
    const targetMonth = date.month() + 1;

    this.setState(
      {
        targetYear: targetYear,
        targetMonth: targetMonth,
      },
      function () {
        // ローカルストレージに保存
        localStorage.setItem('targetYear', targetYear);
        localStorage.setItem('targetMonth', targetMonth);

        this.getPeriodSpecifiedSafetyMapData();
      }
    );
  }

  // イベントタイプ選択時情報を再取得
  selectEventType(eventType) {
    this.setState(
      {
        eventType: eventType,
      },
      function () {
        // ローカルストレージに保存
        localStorage.setItem('eventType', eventType);

        this.getPeriodSpecifiedSafetyMapData();
      }
    );
  }

  // 表示時間：fromを登録
  selectPeriodFrom(from) {
    this.setState({ eventPeriodFrom: from });
    // ローカルストレージに保存
    localStorage.setItem('eventPeriodFrom', from);
  }

  // 表示時間：toを登録
  selectPeriodTo(to) {
    this.setState({ eventPeriodTo: to });
    // ローカルストレージに保存
    localStorage.setItem('eventPeriodTo', to);
  }

  // 期間を指定してイベントデータを取得する
  getPeriodSpecifiedSafetyMapData() {
    // subが無い場合は失敗とする
    if (!this.state.sub) {
      this.setState({
        isSafetyMap: false,
        safetyMapLoading: false,
      });
      return;
    }

    let _this = this;
    let sub = this.state.sub;
    let eventType = this.state.eventType;
    let targetYear = this.state.targetYear
      ? this.state.targetYear
      : moment().year();
    let targetMonth = this.state.targetMonth
      ? this.state.targetMonth
      : moment().month() + 1;

    this.setState({
      isSafetyMap: true,
      safetyMapLoading: true,
    });

    this.getSafetyMapData(sub, eventType, targetYear, targetMonth)
      .then(function (result) {
        _this.setState({
          safetyMapData: result,
          safetyMapLoading: false,
        });
      })
      .catch(function (err) {
        console.log(err);
        _this.setState({
          isSafetyMap: false,
          safetyMapLoading: false,
          showModal: true,
          modalErrorMessage: "SafetyMapApiError",
          modalApiPath: err.response && err.response.request.responseURL,
          modalStatusCode: err.response && err.response.status,
          modalApiMessage: err.response && err.response.data.errorMessage,
          error: !err.response && err,
        });
      });

    // 事故データを取得
    // this.getAccidentData(targetYear, targetMonth)
    //   .then(function (result) {
    //     _this.setState({
    //       accidentDataList: result,
    //       isAccidentData: true,
    //     });
    //   })
    //   .catch(function (err) {
    //     console.log(err);
    //     _this.setState({
    //       accidentDataList: false,
    //       isAccidentData: false,
    //       showModal: true,
    //       modalErrorMessage: "AccidentApiError",
    //       modalApiPath: err.response && err.response.request.responseURL,
    //       modalStatusCode: err.response && err.response.status,
    //       modalApiMessage: err.response && err.response.data.errorMessage,
    //       error: !err.response && err,
    //     });
    //   });

    return;
  }

  // 指定期間・車両のイベント座標リストを取得
  getSafetyMapData(sub, eventType, targetYear, targetMonth) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      let queryParams = {
        sub: sub,
        eventType: eventType,
        targetYear: targetYear,
        targetMonth: targetMonth,
      };

      // APIを実行する
      Api.runApi(
        _this.state.cognitoUser,
        Config.API.STAGE + Config.API.SAFETY_MAP.SAFETY_MAP_DATA_PATH,
        queryParams
      )
        .then(function onFulfilled(result) {
          resolve(result.data);
        })
        .catch(function onRejected(err) {
          reject(err);
        });
    });
  }

  // 指定期間の事故データを取得
  // getAccidentData(reportYear, reportMonth) {
  //   var _this = this;

  //   return new Promise(function (resolve, reject) {
  //     let queryParams = {
  //       reportYear: reportYear,
  //       reportMonth: reportMonth,
  //     };

  //     // APIを実行する
  //     Api.runApi(
  //       _this.state.cognitoUser,
  //       Config.API.STAGE + Config.API.SAFETY_MAP.ACCIDENT_DATA_PATH,
  //       queryParams
  //     )
  //       .then(function onFulfilled(result) {
  //         resolve(result.data);
  //       })
  //       .catch(function onRejected(err) {
  //         reject(err);
  //       });
  //   });
  // }

  render() {
    if (this.state.error) {
      throw new Error(this.state.error);
    }

    return (
      <div id="safety_map">
        <Modal isAospBrowser={false} isLocalStorage={true} />
        {this.state.showModal && (
          <ApiErrorModal
            handleHideModal={this.handleHideModal}
            modalErrorMessage={this.state.modalErrorMessage}
            modalApiPath={this.state.modalApiPath}
            modalStatusCode={this.state.modalStatusCode}
            modalApiMessage={this.state.modalApiMessage}
          />
        )}
        <Switch>
          {/* イベントマップ表示 */}
          <Route exact path="/safety_map">
            <div>
              <Row>
                <Col md={12} sm={12} xs={12} className="safety-map-date">
                  <DatePikerForm
                    month={this.state.targetMonth}
                    year={this.state.targetYear}
                    maxDate={this.state.today}
                    minDate={this.state.minDate}
                    isDate={false}
                    selectDate={this.selectDate}
                  />
                </Col>
              </Row>
              {/* <div className="mini-div" /> */}
              <Row >
                <Col md={12} sm={12} xs={12}>
                  <EventStatsInfo
                    safetyMapData={this.state.safetyMapData}
                    safetyMapLoading={this.state.safetyMapLoading}
                    isSafetyMap={this.state.isSafetyMap}
                    eventType={this.state.eventType}
                    selectEventType={this.selectEventType}
                  />
                </Col>
                <Col md={12} sm={12} xs={12}>
                  <EventPeriodForm
                    eventPeriodFrom={this.state.eventPeriodFrom}
                    eventPeriodTo={this.state.eventPeriodTo}
                    selectPeriodFrom={this.selectPeriodFrom}
                    selectPeriodTo={this.selectPeriodTo}
                  />
                  <EventDetail
                    safetyMapData={this.state.safetyMapData}
                    safetyMapLoading={this.state.safetyMapLoading}
                    isSafetyMap={this.state.isSafetyMap}
                    isAccidentData={this.state.isAccidentData}
                    accidentDataList={this.state.accidentDataList}
                    logCarId={this.state.logCarId}
                    eventPeriodFrom={this.state.eventPeriodFrom}
                    eventPeriodTo={this.state.eventPeriodTo}
                  />
                </Col>
              </Row>
            </div>
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SafetyMap;



// WEBPACK FOOTER //
// ./src/component/SafetyMap/SafetyMap.js